import axios from "axios";
import constant from "../constant";
import { redirectToDigitalAfterLogout } from "../utils/digitalBilling";

const api = axios.create({
  baseURL: `${constant.BACKEDN_BASE_URL}api`,
});


//  Add authorization header to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  const requestUrl = String(config.url || "");
  const isSsoSync =
    requestUrl.includes("/auth/sso-sync") || requestUrl.includes("/auth/login");
  const ssoToken = localStorage.getItem("ssoToken");
  if (ssoToken && !isSsoSync) {
    config.headers["X-SSO-Token"] = ssoToken;
  }
  return config;
});

//  dont thow error on 4XX status codes
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const requestUrl = String(error.config?.url || "");
    const isAuthHandshake =
      requestUrl.includes("/auth/sso-sync") ||
      requestUrl.includes("/auth/login");

    if (error.response?.status === 401 && !isAuthHandshake) {
      redirectToDigitalAfterLogout();
    }
    return Promise.reject(error);
  }
);

export default api;
